module.exports = __webpack_public_path__ + "static/media/34DSS1.1da69391.jpg";